
import React, { useRef } from "react";
import { VictoryBar, VictoryChart, VictoryAxis, VictoryTheme, VictoryPie, VictoryTooltip } from "victory";
import { ChartBarModel } from "../../model/chart/ChartBarModel";
import { ChartPieModel } from "model/chart/ChartPieModel";
import { getCores } from "utils/chartUtils";

type ChartProps = {
    width: number | string | undefined;
    height: number | undefined;
    data: ChartPieModel;
    moneyFormat: boolean;
};

export default function ChartPie(props: ChartProps) {
    function format(value: number): string {
        if(props.moneyFormat){
            return "R$ " + value.toFixed(2).replace(".", ",")
        }
        return value.toString();
    }
    return (
        <div style={{ display: "flex", width: props.width, height: props.height }}>
            <div style={{ width: '60%' }}>
                <VictoryPie
                    colorScale={getCores(props.data.pieces.length)}
                    data={props.data.pieces.map((item) => ({ x: item.name, y: item.value, label: format(item.value) }))}
                    padding={{ top: 10, bottom: 30, left: 50, right: 50 }}
                    innerRadius={60}
                    labelComponent={
                        <VictoryTooltip
                          cornerRadius={10}
                          pointerWidth={30}
                          pointerLength={20}
                          flyoutPadding={{ top: 10, bottom: 10, left: 25, right: 25 }}
                          style={{ fontSize: "36px", fill: "#FFF" }}
                          flyoutStyle={{ fill: "#414B5F" }}
                          orientation="right"
                        />
                      }
                    events={[
                        {
                            target: 'data',
                            eventHandlers: {
                                onMouseOver: () => {
                                    return [
                                        {
                                            target: 'labels',
                                            mutation: () => ({ active: true })
                                        }
                                    ]
                                },
                                onMouseOut: () => {
                                    return [
                                        {
                                            target: 'labels',
                                            mutation: () => ({ active: false })
                                        }
                                    ]
                                }
                            }
                        }
                    ]}
                />
            </div>

            <div style={{ width: '40%', boxSizing: "border-box", flex: 1, height: "100%", overflowY: "scroll" }}>
                {props.data.pieces.map((item, index) => (
                    <div style={{ display: "flex", alignItems: "center", columnGap: 10, width: "100%" }}>
                        <div style={{ minWidth: 20, minHeight: 20, backgroundColor: getCores(props.data.pieces.length)[index], borderRadius: 10 }}></div>
                        <span style={{ textOverflow: "ellipsis", overflow: "hidden" }}>{item.name}</span>
                    </div>
                ))}
            </div>

        </div>
    );
}